import React from 'react';
import { bool, func, object, string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { Modal } from '../../components';
import BehindTheScenesUploadForm from './BehindTheScenesUploadForm';

import css from './BehindTheScenesUploadModal.module.css';

const BehindTheScenesUploadModal = props => {
  const {
    className,
    rootClassName,
    id,
    isOpen,
    onClose,
    onManageDisableScrolling,
    listing,
    uploadedVideos,
    onVideoUpload,
    onRemoveVideo,
    onSubmit,
    uploadInProgress,
    uploadVideoError,
    updateInProgress,
    updateError,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <div className={css.modalHeader}>
        <h2 className={css.modalTitle}>
          <FormattedMessage id="BehindTheScenesUploadModal.title" />
        </h2>
        <p className={css.modalDescription}>
          <FormattedMessage id="BehindTheScenesUploadModal.description" />
        </p>
      </div>

      <BehindTheScenesUploadForm
        listing={listing}
        uploadedVideos={uploadedVideos}
        onVideoUpload={onVideoUpload}
        onRemoveVideo={onRemoveVideo}
        onSubmit={onSubmit}
        uploadInProgress={uploadInProgress}
        uploadVideoError={uploadVideoError}
        updateInProgress={updateInProgress}
        updateError={updateError}
        onClose={onClose}
      />
    </Modal>
  );
};

BehindTheScenesUploadModal.defaultProps = {
  className: null,
  rootClassName: null,
  id: null,
  uploadedVideos: {},
  uploadVideoError: null,
  updateError: null,
};

BehindTheScenesUploadModal.propTypes = {
  className: string,
  rootClassName: string,
  id: string,
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  listing: propTypes.listing.isRequired,
  uploadedVideos: object,
  onVideoUpload: func.isRequired,
  onRemoveVideo: func.isRequired,
  onSubmit: func.isRequired,
  uploadInProgress: bool.isRequired,
  uploadVideoError: propTypes.error,
  updateInProgress: bool.isRequired,
  updateError: propTypes.error,
};

export default BehindTheScenesUploadModal;